import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { Question } from "./GetQuizById";
export type HostedQuizsDTO =  {
    id:string;
    title:string;
    qrCode:string;
    questions:Question[]

}
type getQuizsResponse = {
    statusCode?: number;
    error?: null | ApiError;
    data?: HostedQuizsDTO[];
  
}

export const GetAllHostedQuizs = async ( ): Promise<getQuizsResponse> => {
    try {
        const response = await axios.get(`/quiz/QuizizzHosting`);
            return { data: response.data };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};